/* rhoneprints: 1s and 0s falling down the page. two layers: bright ones in front, and black / dark grey ones far behind the content for depth. lighter on phones, and everything pauses (falling numbers, floating messages, glowing numbers) whenever the page is pinched in even a little, or a photo viewer is open, then comes back when it is back to normal size. while paused the canvases give their memory back, and pinching never makes them rebuild themselves. counts are down about 45% from the original (first a 25% cut, then cut further for lag), and on phones specifically cut another 50% on top of that. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var FONT = '"Space Mono", monospace';
  var phone = window.innerWidth < 750;
  function layoutW() { return document.documentElement.clientWidth || window.innerWidth; }

  function layer(z, css, cfg) {
    var c = document.createElement('canvas');
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:' + z + ';' + (css || '');
    var ctx = c.getContext('2d');
    if (!ctx) return null;
    var L = { c: c, ctx: ctx, W: 0, H: 0, drops: [], cfg: cfg };
    function make(fresh) {
      var k = cfg.size;
      var size = k[0] + Math.pow(Math.random(), cfg.bias) * (k[1] - k[0]);
      return {
        x: Math.random() * L.W,
        y: fresh ? Math.random() * L.H : -size * (1 + Math.random() * 6),
        size: size,
        v: cfg.speed[0] + (size - k[0]) / (k[1] - k[0]) * cfg.speed[1] + Math.random() * cfg.speed[2],
        ch: Math.random() < 0.5 ? '0' : '1',
        col: cfg.colors[Math.floor(Math.random() * cfg.colors.length)],
        flip: 200 + Math.random() * 1600,
        t: 0
      };
    }
    L.make = make;
    L.resize = function (dpr) {
      L.W = layoutW(); L.H = window.innerHeight;
      c.width = Math.round(L.W * dpr); c.height = Math.round(L.H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = cfg.count(L.W);
      while (L.drops.length < n) L.drops.push(make(true));
      if (L.drops.length > n) L.drops.length = n;
    };
    L.free = function () { c.width = 1; c.height = 1; };
    L.draw = function (dt) {
      ctx.clearRect(0, 0, L.W, L.H);
      for (var i = 0; i < L.drops.length; i++) {
        var d = L.drops[i];
        d.y += d.v * dt / 16;
        d.t += dt;
        if (d.t > d.flip) { d.t = 0; d.ch = d.ch === '0' ? '1' : '0'; }
        if (d.y - d.size > L.H) { L.drops[i] = make(false); continue; }
        ctx.font = d.size + 'px ' + FONT;
        ctx.fillStyle = d.col;
        ctx.fillText(d.ch, d.x, d.y);
      }
    };
    return L;
  }

  /* front: dim neon, sparse */
  var front = layer(9994, '', {
    colors: ['#1c8a99', '#7a1c69', '#3a3f8f', '#5a5670', '#1c8a99', '#a8267f'],
    size: [9, 39], bias: 1.6, speed: [0.35, 1.1, 0.4],
    count: function (W) { return Math.round((W < 750 ? 8 : Math.min(46, Math.round(W / 34))) * 0.55); }
  });
  /* back: black and dark grey, big, slow, a little soft (the blur is skipped on phones, it is heavy). sits behind all page content. */
  var back = layer(-1, phone ? '' : 'filter:blur(1.4px);', {
    colors: ['#000000', '#050508', '#17171f', '#1f1f29', '#2a2a35', '#34343f', '#000000', '#22222c'],
    size: [26, 96], bias: 1.2, speed: [0.12, 0.35, 0.15],
    count: function (W) { return Math.round((W < 750 ? 9 : Math.min(46, Math.round(W / 38))) * 0.55); }
  });
  var layers = [back, front].filter(Boolean);
  if (!layers.length) return;

  /* let the back layer show through the page: the page background moves to <html>, the sections that share it go clear.
     while paused (zoomed in), the floating things hide too, which also freezes their animations. */
  var st = document.createElement('style');
  st.textContent =
    'html{background:var(--gradient-background,rgb(var(--color-background)))}' +
    'body.gradient{background:transparent}' +
    '#MainContent .shopify-section>.color-scheme-1.gradient{background:transparent}' +
    'body.gl-zoomed .gl-glow,body.gl-zoomed .gl-whisper,body.gl-zoomed .gl-gcat,body.gl-zoomed .gl-gbit,body.gl-zoomed .gl-conf,body.gl-zoomed .gl-tally,body.gl-zoomed .gl-win{display:none!important}';
  if (back) document.head.appendChild(st);

  /* paused when: the page is pinched in even a little (visual viewport scale above 1), or the theme's photo viewer is open */
  function zoomed() {
    if (!document.body) return false;
    var vv = window.visualViewport;
    if (vv && vv.scale && Math.abs(vv.scale - 1) > 0.03) return true;
    return !!document.querySelector('product-modal[open], .product-media-modal[open], .media-modal[open], modal-dialog[open]') ||
      (document.body.classList.contains('overflow-hidden') && !!document.querySelector('.product-media-modal'));
  }
  window.__glZoomed = zoomed;
  var last = 0, running = true, hidden = false, lw = 0, lh = 0, calm = 0;
  function resize() {
    var dpr = phone ? 1 : Math.min(2, window.devicePixelRatio || 1);
    lw = layoutW(); lh = window.innerHeight;
    layers.forEach(function (L) { L.resize(dpr); });
  }
  function setHidden(h) {
    if (h === hidden) return;
    hidden = h;
    layers.forEach(function (L) { L.c.style.display = h ? 'none' : ''; if (h) L.free(); });
    if (document.body) document.body.classList.toggle('gl-zoomed', h);
    if (!h) resize();
  }
  function frame(now) {
    if (!running) return;
    if (zoomed()) {
      calm = 0;
      setHidden(true);
      setTimeout(function () { requestAnimationFrame(frame); }, 250);
      return;
    }
    /* back to normal size: wait a moment so a pinch that is still settling doesn't rebuild things mid-gesture */
    if (hidden) {
      if (++calm < 4) { setTimeout(function () { requestAnimationFrame(frame); }, 150); return; }
      setHidden(false); last = 0;
    }
    var dt = Math.min(50, now - last || 16);
    last = now;
    layers.forEach(function (L) { L.draw(dt); });
    requestAnimationFrame(frame);
  }
  function mount() {
    if (!document.body || layers[0].c.parentNode) return;
    layers.forEach(function (L) { document.body.appendChild(L.c); });
    resize();
    requestAnimationFrame(frame);
  }
  /* only rebuild the canvases when the real page size changes (turning the phone, resizing the window),
     never while pinching or when the address bar slides in and out */
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (hidden || zoomed()) return;
      if (Math.abs(layoutW() - lw) < 2 && Math.abs(window.innerHeight - lh) < 150) return;
      resize();
    }, 350);
  });
  document.addEventListener('visibilitychange', function () {
    running = !document.hidden;
    if (running) { last = 0; requestAnimationFrame(frame); }
  });
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
})();
